import utils from '@/mixins/utils.js'

export const dataFields = {
  CNES: 'nu_cnes',
  UBS: 'no_unidade_saude',
  INE: {
    field: 'nu_ine',
    callback: (value) => {
      return value !== '' ? `​  ​​${value.toString()}` : ''
    },
  },
  EQUIPE: 'no_equipe',
  CIDADÃOS: 'cidadaos',
  PERÍODO: {
    field: 'mes_ano',
    callback: (value) => {
      return value !== '' ? `​  ​​${value.toString()}` : ''
    },
  },
  INDICADOR: 'no_indicador',
  RESULTADO: {
    field: 'resultado',
    callback: (value) => {
      return value !== '' ? value + '%' : ''
    },
  },
  ATENÇÃO: 'recomendacao_resultado',
}

export const infoHtml = `
`
